import type { Node } from '@xyflow/react';
import { Handle, Position } from '@xyflow/react';

interface StartNodeData extends Record<string, unknown> {
  label: string;
  type: 'start';
  initialVariables?: Record<string, unknown>;
}

type StartNode = Node<StartNodeData>;

interface StartNodeProps {
  data: StartNodeData;
  selected?: boolean;
}

export default function StartNode({ data, selected }: StartNodeProps) {
  return (
    <div
      style={{
        width: '64px',
        height: '64px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #22c55e 0%, #16a34a 100%)',
        border: selected ? '3px solid #15803d' : '2px solid #22c55e',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '12px',
        fontWeight: 'bold',
        boxShadow: selected
          ? '0 0 0 4px rgba(34, 197, 94, 0.3), 0 4px 12px rgba(0, 0, 0, 0.15)'
          : '0 4px 12px rgba(0, 0, 0, 0.15)',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
    >
      <span style={{ textAlign: 'center', padding: '4px' }}>{data.label}</span>
      <Handle
        type="source"
        position={Position.Bottom}
        style={{
          width: '12px',
          height: '12px',
          background: '#22c55e',
          border: '2px solid white',
        }}
      />
    </div>
  );
}
